/* eslint-ignore */
// @ts-nocheck
import React from "react";

import { Container, TolltipItens, TooltipContainer } from "./styles";

type CustomTooltipProps = {
  className?: string;
  children: React.ReactNode;
};

const CustomTooltipOldPassword: React.FC<CustomTooltipProps> = ({
  className,
  children,
}) => {
  return (
    <Container className={className}>
      {children}
      <TooltipContainer>
        <TolltipItens>
          <span>
            {`Caso não lembre sua senha atual, ao clicar no link você será deslogado e direcionado para a seção "Esqueci minha senha"`}
          </span>
        </TolltipItens>
      </TooltipContainer>
    </Container>
  );
};

export default CustomTooltipOldPassword;
